module.exports = __webpack_public_path__ + "static/assets/7dc2c3e9d1c47094a1fad03e3f77aa1f.svg";